import {
  Container,
  Button,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Row,
  Form,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';

export const Footer = () => {
  return (
    <footer
      className='registration-footer text-white py-5'
      style={{ background: '#3c3f46' }}
    >
      <Container>
        <Row>
          <Col md={6} lg={9}>
            <h4 className='text-primary'>Help Hope Live</h4>
            <div>
              2 Radnor Corporate Center, Suite 100
              <br />
              100 Matsonford Road
              <br />
              Radnor, PA 19087
            </div>
          </Col>
          <Col md={6} lg={3}>
            <Card
              style={{ background: 'transparent', border: '2px solid #fff' }}
            >
              <CardBody className='text-center'>
                <h4 className='text-white'>Need Assistance?</h4>
                <p className='text-white'>
                  You can reach us at <a href='tel:8006428399'>800-642-8399</a>
                  <br />
                  Mon-Fri 9 AM-6 PM ET
                </p>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
